// Fetch referrals
export async function fetchAllReferrals() {
  try {
    const response = await fetch(`/api/referrals?all=true`);
    // if (!response.ok) {
    //   return { error: 'Network response was not ok' };
    // }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching referrals:', error);
    return {
      error: error.message
    };
  }
}
export async function getReferrer() {
  try {
    const response = await fetch(`/api/referrals/getReferrer`);
    // if (!response.ok) {
    //   return { error: 'Network response was not ok' };
    // }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching referrals:', error);
    return {
      error: error.message
    };
  }
}
/* export async function deleteAllReferrals(): Promise<FetchResult<TReferral | TReferral[]>> {
  try {
    const response = await fetch(`/api/referrals?del=true`);
    console.log('deleteAllReferrals response', response);

    if (!response.ok) {
      return { error: 'Network response was not ok' };
    }

    const data: TReferral | TReferral[] = await response.json();

    return { data };
  } catch (error) {
    console.error('Error fetching referrals:', error);
    return { error: error.message };
  }
} */
// Fetch referrals
export async function fetchReferrals({
  ethAddress,
  refererUserId,
  referralId,
  refereeUserId,
  getReffereeEthAddresses
}) {
  try {
    const params = new URLSearchParams();
    if (ethAddress) params.append('ethAddress', ethAddress);
    if (refererUserId) params.append('refererUserId', refererUserId === null || refererUserId === void 0 ? void 0 : refererUserId.toString());
    if (referralId) params.append('referralId', referralId === null || referralId === void 0 ? void 0 : referralId.toString());
    if (refereeUserId) params.append('refereeUserId', refereeUserId === null || refereeUserId === void 0 ? void 0 : refereeUserId.toString());
    if (getReffereeEthAddresses) params.append('getReffereeEthAddresses', 'true');
    const response = await fetch(`/api/referrals?${params === null || params === void 0 ? void 0 : params.toString()}`);
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error fetching referrals:', error);
    return {
      error: error.message
    };
  }
}
// Create new referral
export async function createReferral(newReferral) {
  try {
    const response = await fetch('/api/referrals', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newReferral)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error creating referral:', error);
    return {
      error: error.message
    };
  }
}
// Update existing referral
export async function updateReferral(updatedReferral) {
  try {
    const response = await fetch('/api/referrals', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedReferral)
    });
    if (!response.ok) {
      return {
        error: 'Network response was not ok'
      };
    }
    const data = await response.json();
    return {
      data
    };
  } catch (error) {
    console.error('Error updating referral:', error);
    return {
      error: error.message
    };
  }
}